<ng-container *ngIf="(passwordValidated$ | async) === false; else editEmail">
  <app-profile-validate-password
    [validatePasswordLoading]="loading$ | async"
    (cancelValidate)="onCancel()"
    (validatePassword)="onValidatePassword($event)"
  ></app-profile-validate-password>
</ng-container>
<ng-template #editEmail>
  <h3 class="ui-headline">{{ 'kids.verification_screen.email' | translate }}</h3>
  <form [formGroup]="emailForm" #emailFormDirective="ngForm" (ngSubmit)="onUpdateEmail()">
    <div class="input-box">
      <label for="profile-email">{{ '2fa.forgot_password.email' | translate }}</label>
      <input appAutoFocus id="profile-email" type="email" formControlName="email" />
      <p *ngIf="emailFormDirective?.submitted && emailControl?.hasError('required')" class="error empty">
        {{ 'profile.personalDetails.error.empty' | translate }}
      </p>
      <p *ngIf="emailFormDirective?.submitted && !emailControl?.hasError('required') && !emailControl.valid" class="error empty">
        {{ 'profile.personalDetails.error.format' | translate }}
      </p>
    </div>
    <!--/.input-box-->
    <div class="ui-button-group">
      <button type="submit" class="ui-button" [class.loading]="loading$ | async">
        <span class="icon-i-windmill"></span>
        {{ 'personal.send' | translate }}
      </button>
      <button (click)="onCancel()" class="ui-button-text">
        <span>{{ 'modals.consultation.cta.cancel' | translate }}</span>
      </button>
    </div>
  </form>
</ng-template>
